
import ReducersFactory from '../../lib/reducers/ReducersFactory';

const customReducers = {
    resetUserAnswers: (state, action) => {
        Object.keys(state.items).map(id => {
            state.items[id] = null
        })
    },
    updateUserAnswer: (state, action) => {
        const id = action.payload.id
        const data = action.payload.val

        state.items[id] = data
    },
}

const userAnswers = new ReducersFactory('userAnswers', ['updateUserAnswer', 'resetUserAnswers'], false, customReducers)

export const { 
    updateUserAnswer,
    resetUserAnswers
} = userAnswers.actions


export default userAnswers.reducer